module.exports = __webpack_public_path__ + "img/68-r.069cfebe.png";